import AuthService from '../../services/authService';
import UserService from '../../pages/user/services/userService';
import TopbarController from './topbarController';
import './topbar.scss';

/**
 * @param hideUser - determines to show/hide user email and login button
 * @param title {String} - title on the topBar
 * @type {{template: *, controller: TopbarController, bindings: {showUser: string, title: string}}}
 */
const TopbarComponent = {
    template: require('./topbarView.html'),
    controller: TopbarController,
    bindings: {
        hideUser: '<?',
        title: '@?',
    },
};

export default angular.module('app.topbar', [])
    .component('topbar', TopbarComponent)
    .service('AuthService', AuthService)
    .service('UserService', UserService)
    .name;




// WEBPACK FOOTER //
// ./src/app/components/topbar/topbarComponent.js